const reviews = [
  {
    name: 'Marco Rossi',
    location: 'Ravenna Centro',
    initials: 'MR',
    rating: 5,
    text: 'Servizio eccellente! Hanno installato la stufa a pellet in un solo giorno con grande professionalità. Il tecnico ha spiegato tutto il funzionamento e ci ha lasciato con il sorriso. Consigliatissimi!',
    date: 'Ottobre 2024',
  },
  {
    name: 'Giulia Toscani',
    location: 'Marina di Ravenna',
    initials: 'GT',
    rating: 5,
    text: 'Chiamati di sera per un guasto improvviso, sono arrivati entro 2 ore. Rapidi, competenti e prezzi onesti. Non cambierei mai per qualsiasi problema con la stufa.',
    date: 'Novembre 2024',
  },
  {
    name: 'Alessandro Pieri',
    location: 'Classe, Ravenna',
    initials: 'AP',
    rating: 4,
    text: 'Ottima manutenzione annuale. La stufa ora funziona molto meglio di prima e i consumi sono calati. Personale cortese e puntuale. Tornerò sicuramente il prossimo anno.',
    date: 'Settembre 2024',
  },
  {
    name: 'Francesca Mazzini',
    location: 'Lido Adriano',
    initials: 'FM',
    rating: 5,
    text: 'Ho scelto la stufa su loro consiglio e sono contentissima. Mi hanno guidata nella scelta giusta per la mia casa, rispettando il budget. Installazione perfetta, senza nessun problema.',
    date: 'Dicembre 2024',
  },
  {
    name: 'Roberto Castellani',
    location: 'Fornace Zarattini',
    initials: 'RC',
    rating: 5,
    text: 'Professionisti veri. Disponibili 24 ore su 24 come promettono: a Natale la stufa si è bloccata e in meno di 3 ore ero di nuovo al caldo. Prezzi corretti, lavoro impeccabile.',
    date: 'Gennaio 2025',
  },
  {
    name: 'Simona Bartolini',
    location: "Sant'Alberto, Ravenna",
    initials: 'SB',
    rating: 4,
    text: 'Molto soddisfatta del servizio di manutenzione. Puntuali, precisi e gentili. Hanno anche fatto alcune piccole riparazioni non previste senza costi aggiuntivi. Grazie mille!',
    date: 'Febbraio 2025',
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map((i) => (
        <div key={i} className="w-4 h-4 flex items-center justify-center">
          <i className={`ri-star-${i <= count ? 'fill' : 'line'} text-orange-400 text-base`}></i>
        </div>
      ))}
    </div>
  );
}

const avatarColors = [
  'bg-orange-400',
  'bg-red-400',
  'bg-amber-500',
  'bg-orange-500',
  'bg-red-500',
  'bg-amber-400',
];

export default function Recensioni() {
  const avgRating = 4.5;
  const totalReviews = 15;

  return (
    <section id="recensioni" className="py-20 md:py-28 bg-[#F7F3EE]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-12">
          <div>
            <div className="inline-flex items-center gap-2 bg-orange-500 text-white text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-wider mb-4">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-star-fill text-sm"></i>
              </div>
              {avgRating} su 5 stelle
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 leading-tight">
              Cosa dicono i nostri<br />
              <span className="text-orange-500">clienti di Ravenna</span>
            </h2>
          </div>

          {/* Rating Summary */}
          <div className="bg-white rounded-2xl p-6 flex items-center gap-6 flex-shrink-0">
            <div className="text-center">
              <p className="text-5xl font-extrabold text-orange-500">{avgRating}</p>
              <Stars count={Math.round(avgRating)} />
              <p className="text-xs text-gray-400 mt-1">{totalReviews} recensioni</p>
            </div>
            <div className="flex flex-col gap-2 w-36">
              {[5, 4, 3, 2, 1].map((star) => {
                const pct = star === 5 ? 73 : star === 4 ? 20 : star === 3 ? 7 : 0;
                return (
                  <div key={star} className="flex items-center gap-2">
                    <span className="text-xs text-gray-500 w-2">{star}</span>
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-orange-300 text-xs"></i>
                    </div>
                    <div className="flex-1 h-1.5 bg-gray-100 rounded-full overflow-hidden">
                      <div
                        className="h-full bg-orange-400 rounded-full"
                        style={{ width: `${pct}%` }}
                      ></div>
                    </div>
                    <span className="text-xs text-gray-400 w-6">{pct}%</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {reviews.map((review, index) => (
            <div
              key={review.name}
              className="bg-white rounded-2xl p-6 flex flex-col gap-4 transition-transform hover:-translate-y-1"
            >
              {/* Top: Avatar + Name */}
              <div className="flex items-center gap-3">
                <div
                  className={`w-12 h-12 flex items-center justify-center rounded-full ${avatarColors[index % avatarColors.length]} flex-shrink-0`}
                >
                  <span className="text-white font-bold text-sm">{review.initials}</span>
                </div>
                <div>
                  <p className="font-bold text-gray-900 text-sm">{review.name}</p>
                  <div className="flex items-center gap-1">
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-map-pin-2-fill text-orange-400 text-xs"></i>
                    </div>
                    <p className="text-xs text-gray-400">{review.location}</p>
                  </div>
                </div>
              </div>

              {/* Stars */}
              <Stars count={review.rating} />

              {/* Text */}
              <p className="text-gray-600 text-sm leading-relaxed flex-1">
                &laquo;{review.text}&raquo;
              </p>

              {/* Date */}
              <p className="text-xs text-gray-300 font-medium">{review.date}</p>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-10">
          <p className="text-gray-500 text-sm mb-4">
            Oltre <strong className="text-gray-700">15 clienti soddisfatti</strong> nella zona di Ravenna
          </p>
          <a
            href="tel:+393806328251"
            className="inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white text-sm font-bold px-7 py-3.5 rounded-full transition-all cursor-pointer whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-fill text-sm"></i>
            </div>
            Diventa il nostro prossimo cliente soddisfatto
          </a>
        </div>

      </div>
    </section>
  );
}
